import { render, staticRenderFns } from "./payDialog.vue?vue&type=template&id=2159586e&scoped=true"
import script from "./payDialog.vue?vue&type=script&lang=js"
export * from "./payDialog.vue?vue&type=script&lang=js"
import style0 from "./payDialog.vue?vue&type=style&index=0&id=2159586e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2159586e",
  null
  
)

export default component.exports